module.exports = __webpack_public_path__ + "img/taxi_demo-400x300.644d70eb.jpg";